import { actions } from 'actions';

const initalState = {
  breadcrumb: '',
  id: ''
};

/**
 * パンくずリストの任意文字列部分
 */
const breadcrumbReducer = (state = initalState, action) => {
  switch (action.type) {
    // メッセージセット
    case actions.SET_BREADCRUMB:
      return {
        breadcrumb: action.breadcrumb,
        id: action.id
      };
    // メッセージクリアー
    case actions.CLEAR_BREADCRUMB:
      return initalState;
    default:
      return state;
  }
};

export default breadcrumbReducer;
